'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HoverPopup = function HoverPopup(props) {
	var show = props.show,
	    title = props.title,
	    text = props.text,
	    position = props.position,
	    extraClass = props.extraClass;


	var hoverClass = (0, _classnames2.default)({
		'show': show,
		'hoverPopup': true,
		extraClass: true
	});

	var customStyles = {
		left: position.left,
		bottom: position.bottom
	};

	return _react2.default.createElement(
		'div',
		{ className: hoverClass, style: customStyles },
		_react2.default.createElement(
			'span',
			{ className: 'title' },
			title
		),
		_react2.default.createElement(
			'span',
			{ className: 'text' },
			text
		)
	);
};

HoverPopup.propTypes = {
	show: _react.PropTypes.bool.isRequired,
	title: _react.PropTypes.string.isRequired,
	text: _react.PropTypes.string.isRequired,
	position: _react.PropTypes.object
};

exports.default = HoverPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/HoverPopup.js
// module id = 798
// module chunks = 0